import React from "react";
import { NavAndroid, NavApp, NavAppLink, NavArrow, NavIOS, NavLink, NavAppModal, NavAppModalIcons, NavQRCode } from "./styles";
import { Triangle, TriangleShadow } from "../../styles";
import getLangKeyValueFun from "../../../../utils/lang";
import langGroup from "../../../../assets/lang.json";
import { ANDROID_DOWNLOAD, APP_DOWNLOAD, IOS_DOWNLOAD } from "../../utils";
const getText = getLangKeyValueFun(langGroup);
class MobileApps extends React.Component {
    constructor() {
        super(...arguments);
        this.onOpenAppDownload = () => {
            window.open(APP_DOWNLOAD());
        };
        this.onOpenIOSDownload = () => {
            window.open(IOS_DOWNLOAD);
        };
        this.onOpenAndroidDownload = () => {
            window.open(ANDROID_DOWNLOAD);
        };
    }
    render() {
        const { lowPriceCountryPriceOff } = this.props;
        return (React.createElement(NavApp, null,
            React.createElement(NavLink, { onClick: this.onOpenAppDownload, dangerouslySetInnerHTML: {
                    __html: lowPriceCountryPriceOff ? lowPriceCountryPriceOff :
                        `<b>${getText("10% OFF")}&nbsp;</b>${getText("for App User")}`
                } }),
            React.createElement(NavAppModal, null,
                React.createElement(Triangle, null),
                React.createElement(TriangleShadow, null),
                React.createElement(NavAppModalIcons, null,
                    React.createElement(NavQRCode, null),
                    React.createElement(NavAppLink, { onClick: this.onOpenIOSDownload },
                        React.createElement(NavIOS, null)),
                    React.createElement(NavAppLink, { onClick: this.onOpenAndroidDownload },
                        React.createElement(NavAndroid, null)))),
            React.createElement(NavArrow, null)));
    }
}
export default MobileApps;
